<template>
  <div class="navigation" v-auto-animate>
    <NuxtLink v-for="item in items" :to="item.path" :key="item.id" :class="{ 'is-active': item.active, 'sr-only': !item.visible }">
      <div class="navigation__icon" v-if="item.icon">
          <AtomIcon :name="item.icon" />
        </div>
      <div class="navigation__text" v-html="item.title" />
    </NuxtLink>
  </div>
</template>

<script setup>
import navItems from '~/data/nav.js'

const route = useRoute()
const fat = useFatStore()
const app = useAppStore()

// Paths that requires a minimum number of restaurants
const bigCityPaths = [
  '/bokningsforfragan',
  '/presentkort/{citySlug}',
]

// Get all featured cities (for nav when user is missing city ID in FAT)
const featuredCities = computed(() => app.cities
  ?.filter(city => city?.sections)
  ?.map(city => ({
    id: city.id,
    title: city.name,
    path: `/${city.slug}`,
    icon: null,
    active: null,
    visible: !fat.cityId,
  })))

// Create city items based on sections 
const cityItems = computed(() => {
  const city = app.cities?.find(city => city.id === fat.cityId)

  return navItems
    .filter(item => fat.cityId)
    .filter(item => !bigCityPaths.includes(item.path) || city.restaurants > 2)
    .filter(item => !item?.type || city.sections?.includes(item.type))
    .map(item => ({
      id: item?.id,
      title: item.title,
      path: item.path.replace('{citySlug}', fat.city?.slug),
      icon: iconLookup[useSlugify(item.title)],
      active: route.params?.all ? item?.path?.startsWith('/' + route.params?.all[0]) : false,
      visible: fat.cityId = city.id,
    }))
})

// Featured cities and city items
const items = computed(() => [
  ...cityItems.value,
  ...featuredCities.value,
])

// Icon Lookup
const iconLookup = {
  start: 'house-blank',
  restauranger: 'utensils',
  guider: 'file-lines',
  artiklar: 'pen-clip',
  evenemang: 'calendar',
  erbjudanden: 'badge-percent',
  'stora-sallskap': 'user-group',
  presentkort: 'gift',
  appen: 'mobile',
}
</script>

<style lang="scss" scoped>
.navigation {
  @apply text-base;

  a {
    @apply block py-2 whitespace-nowrap;
    @apply flex items-center gap-3 duration-300;

    &.is-active,
    &.router-link-active {
      @apply text-coral;
    }
  }

  &__icon {
    @apply text-coral w-6 text-xl -mt-px;
  }

  &__text {
    @apply font-heading font-medium text-xl tracking-wide;
  }  
}
</style>

